import { fetchAPI } from 'utils/api';

export const convertMoney = (
  amount: number,
  from_currency: string,
  to_currency: string
) =>
  fetchAPI('/payment/convert', {
    method: 'POST',
    version: '1.2',
    payload: {
      amount,
      from_currency,
      to_currency,
    },
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./app/api/payment.ts